import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { IProfile } from '../../utils/interfaces/profile';
import { IResponse } from '../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly URI_API = environment.apiConfig.uri + 'Role';

  constructor(private readonly httpClient: HttpClient) {}

  getAllProfile(): Observable<IResponse<IProfile[]>> {
    return this.httpClient.get<IResponse<IProfile[]>>(`${this.URI_API}/all`);
  }

  changeStatusProfile(profileId: string): Observable<IResponse<boolean>> {
    return this.httpClient.patch<IResponse<boolean>>(
      `${this.URI_API}/toggle-status?roleId=${profileId}`,
      {}
    );
  }

  createProfile(profile: string): Observable<IResponse<string>> {
    return this.httpClient.post<IResponse<string>>(
      `${this.URI_API}/create?roleName=${profile}`,
      {}
    );
  }

  updateProfile(
    profileId: string,
    profile: string
  ): Observable<IResponse<string>> {
    return this.httpClient.put<IResponse<string>>(
      `${this.URI_API}/update?roleId=${profileId}&roleName=${profile}`,
      {}
    );
  }

  deleteProfile(profileId: string): Observable<IResponse<boolean>> {
    return this.httpClient.delete<IResponse<boolean>>(
      `${this.URI_API}/delete?roleId=${profileId}`
    );
  }
}
